export default {
  REDUX_NAMESPACE: 'IULI/INVOICE_DOWNLOADS',

  SET_FILTER: 'INVOICE_DOWNLOADS/SET_FILTER',
  SET_FILTER_COMPETENCY_DATE: 'INVOICE_DOWNLOADS/SET_FILTER_COMPETENCY_DATE',
  SET_FILTER_INVOICE_DATE: 'INVOICE_DOWNLOADS/SET_FILTER_INVOICE_DATE',
  SET_FILTER_INVOICE_STATUS: 'INVOICE_DOWNLOADS/SET_FILTER_INVOICE_STATUS',
  SET_FILTER_INVOICE_OPERATION:
    'INVOICE_DOWNLOADS/SET_FILTER_INVOICE_OPERATION',
  SET_FILTER_INVOICE_TYPE: 'INVOICE_DOWNLOADS/SET_FILTER_INVOICE_TYPE',

  SET_SORT_MODEL: 'INVOICE_DOWNLOADS/SET_SORT_MODEL',

  SET_PAGE_SIZE: 'INVOICE_DOWNLOADS/SET_PAGE_SIZE',

  SET_INITIAL_STATE: 'INVOICE_DOWNLOADS/SET_INITIAL_STATE',
};
